export const REMOVE_SP_WORKER_REGISTRATION_DATA = 'REMOVE_SP_WORKER_REGISTRATION_DATA';
export const SET_SP_WORKER_SERVICES_CHOSEN_INFO = 'SET_SP_WORKER_SERVICES_CHOSEN_INFO';
export const SET_SP_WORKER_CERTIFICATIONS_CHOSEN_INFO = 'SET_SP_WORKER_CERTIFICATIONS_CHOSEN_INFO';
export const SET_SP_WORKER_GENERAL_INFO = 'SET_SP_WORKER_GENERAL_INFO';
export const SET_SP_WORKER_AVATAR = 'SET_SP_WORKER_AVATAR';
export const CLEAR_SP_WORKER_AVATAR = 'CLEAR_SP_WORKER_AVATAR';
export const CLEAR_SP_WORKER_CHOSEN_CERTIFICATE = 'CLEAR_SP_WORKER_CHOSEN_CERTIFICATE';
export const CLEAR_SP_WORKER_CHOSEN_SERVICES = 'CLEAR_SP_WORKER_CHOSEN_SERVICES';
export const CLEAR_SP_WORKER_GENERAL_INFO = 'CLEAR_SP_WORKER_GENERAL_INFO';
